import React from "react";
import {
  Card,
  CardBody,
  Col,
  CustomInput,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Select from "react-select";
import { PdfApiUrl } from "../../Helper/Additional";
import Notiflix from "notiflix";
const UserVerification = ({
  handleInputChange,
  setUpdatedValues,
  updatedValues,
}) => {
  const addressProof = [
    { value: "Aadhar", label: "Aadhar" },
    { value: "Water Bill", label: "Water Bill" },
    { value: "Electricity Bill", label: "Electricity Bill" },
  ];
  const idProof = [
    { value: "Aadhar", label: "Aadhar" },
    { value: "Pancard", label: "Pancard" },
    { value: " Driving License", label: " Driving License" },
  ];

  const fileConverterHandler = async (newFile, type) => {
    const form = new FormData();

    form.append("file", newFile);
    form.append("foldername", "Job/Auditor");
    form.append("filename", `doc-${new Date()}`);

    fetch(PdfApiUrl, {
      method: "POST",
      body: form,
    })
      .then((res) => res.json())
      .then((result) => {
        setUpdatedValues((prevValues) => ({
          ...prevValues,
          type: result?.Message,
        }));
        // setImagePreviewUrl(result?.Message);
      });
  };

  return (
    <div className="inner-box mt-2">
      <p className="headingStyle ml-4">Verification</p>
      <CardBody>
        <div>
          <Row>
            <Col sm="4">
              <FormGroup>
                <Label htmlFor="">
                  Identity Proof<span className="mandatory">*</span>
                </Label>
                <Select
                  className="React"
                  classNamePrefix="select"
                  name="IDProof"
                  onChange={(selectedOption) => {
                    setUpdatedValues((prevValues) => ({
                      ...prevValues,
                      IDProof: selectedOption,
                    }));
                  }}
                  value={updatedValues?.IDProof}
                  options={idProof}
                />
              </FormGroup>
            </Col>

            <Col sm="4">
              <FormGroup>
                <Label htmlFor="nameVertical">
                  Document Number<span className="mandatory">*</span>
                </Label>
                <Input
                  type="text"
                  name="IdProofNumber"
                  id="nameVertical"
                  placeholder="ID Number"
                  value={updatedValues?.IdProofNumber}
                  onChange={handleInputChange}
                />
              </FormGroup>
            </Col>

            <Col sm="4">
              <FormGroup>
                <Label htmlFor="nameVertical">
                  Document Proof{" "}
                  {updatedValues?.identityProofFile ? (
                    <a
                      href={updatedValues?.identityProofFile}
                      target="__blank"
                      className="ml-2 text-primary"
                    >
                      ( View )
                    </a>
                  ) : (
                    "(upload .pdf file)"
                  )}
                  <span className="mandatory cursor-pointer">*</span>
                </Label>

                <CustomInput
                  type="file"
                  name="identityProofFile"
                  accept="application/pdf"
                  id="nameVertical"
                  onChange={(e) => {
                    e.preventDefault();
                    const file = e.target.files[0];
                    fileConverterHandler(file, "identityProofFile");
                    // formik.setFieldValue("identityProofFile", file);

                    if (file && file.size > 5000000) {
                      Notiflix.Notify.failure(
                        "File too large, upload file less than 5 Mb."
                      );
                    }
                  }}
                />
              </FormGroup>
            </Col>

            <Col sm="4">
              <FormGroup>
                <Label htmlFor="">
                  {" "}
                  Address Proof<span className="mandatory">*</span>
                </Label>
                <Select
                  className="React"
                  classNamePrefix="select"
                  name="AddressProof"
                  options={addressProof}
                  onChange={(selectedOption) => {
                    setUpdatedValues((prevValues) => ({
                      ...prevValues,
                      AddressProof: selectedOption,
                    }));
                  }}
                  value={updatedValues?.AddressProof}
                />
              </FormGroup>
            </Col>

            <Col sm="4">
              <FormGroup>
                <Label htmlFor="nameVertical">
                  Document Number<span className="mandatory">*</span>
                </Label>
                <Input
                  type="text"
                  name="AddressProofNumber"
                  id="nameVertical"
                  placeholder="ID Number"
                  value={updatedValues?.AddressProofNumber}
                  onChange={handleInputChange}
                />
              </FormGroup>
            </Col>

            <Col sm="4">
              <FormGroup>
                <Label htmlFor="nameVertical">
                  Document Proof{" "}
                  {updatedValues?.AddressProofFile ? (
                    <a
                      href={updatedValues?.AddressProofFile}
                      target="__blank"
                      className="ml-2 text-primary"
                    >
                      ( View )
                    </a>
                  ) : (
                    "(upload .pdf file)"
                  )}
                  <span className="mandatory cursor-pointer">*</span>
                </Label>

                <CustomInput
                  type="file"
                  name="AddressProofFile"
                  accept="application/pdf"
                  id="nameVertical"
                  onChange={(e) => {
                    e.preventDefault();
                    const file = e.target.files[0];
                    // formik.setFieldValue("AddressProofFile", file);
                    fileConverterHandler(file, "AddressProofFile");
                    if (file && file.size > 5000000) {
                      Notiflix.Notify.failure(
                        "File too large, upload file less than 5 Mb."
                      );
                    }
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        </div>
      </CardBody>
    </div>
  );
};

export default UserVerification;
